import { render, staticRenderFns } from "./tabs-head.vue?vue&type=template&id=0ea6531d&scoped=true&"
import script from "./tabs-head.vue?vue&type=script&lang=js&"
export * from "./tabs-head.vue?vue&type=script&lang=js&"
import style0 from "./tabs-head.vue?vue&type=style&index=0&id=0ea6531d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea6531d",
  null
  
)

export default component.exports